import React, { FunctionComponent } from 'react';

export const DangerousHtml: FunctionComponent<{ html: string }> = ({ html }) => (
  <span dangerouslySetInnerHTML={{ __html: html }} />
);
DangerousHtml.displayName = 'DangerousHtml';
